import * as Vue from "vue";
import * as mutations from "../../mutation-types"
import axios from "axios"

export const processRole = (store, role) => {
    store.commit(mutations.ADD_OR_UPDATE_ROLE, role)
};

export const fetchRoles = (store, params) => {
    return axios.get(`/api/roles`, { params })
        .then(res => {
            _.each(res.data.data, item => processRole(store, item))
            return res
        })
}

export const createRole = (store, role = {}) => {
    return axios.post(`/api/roles`, role)
        .then(response => {
            store.commit(mutations.ADD_OR_UPDATE_ROLE, response.data.data)
            return response
        });
};

export const updateRole = (store, role = {}) => {
    return axios.patch(`/api/roles/${role.id}`, role)
        .then(response => {
            store.commit(mutations.ADD_OR_UPDATE_ROLE, response.data.data)
            return response
        });
}

export const createOrUpdateRole = (store, item) => {
    return item.id ?
        updateRole(store, item) :
        createRole(store, item)
}

export const fetchRoleById = (store, id) => {
    return axios.get(`/api/roles/${id}`).then(response => {
        processRole(store, response.data.data)
        return response
    })
};

export const removeRole = (store, item) => {
    return axios.delete(`/api/roles/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_ROLE, item)
            return res
        })
}